import {Search} from '../api/search/queries';
import {useQuery} from '@apollo/client';
import {useEffect, useState} from 'react';

type ElasticSearchResult = Record<string, any>;

interface SearchQueryProps {
  searchTerm: string;
  store: {
    platform: {
      getLanguage: () => string;
    };
  };
  skipSearch?: boolean;
  size?: number;
  tags?: string[];
}

export const useSearchQuery = ({searchTerm, store, skipSearch, size, tags}: SearchQueryProps) => {
  const {platform} = store;
  const {data, loading, error} = useQuery(Search, {
    skip: skipSearch,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    variables: {searchTerm, locale: platform.getLanguage(), tags, size}
  });

  const [lastQueryResults, setLastQueryResults] = useState<ElasticSearchResult[]>([]);
  useEffect(() => {
    if (loading) {
      return;
    }
    setLastQueryResults(data?.search?.results);
  }, [data, loading]);

  return {lastQueryResults, loading, error};
};
